/** Cấp VIP — key API trùng tên hiển thị (predict-match-config / vipLevels) */
export const VIP_TIER_KEYS = [
  "NEW",
  "NORMAL",
  "COPPER",
  "SILVER",
  "GOLD",
  "PLATINUM",
  "EMERALD",
  "SAPPHIRE",
  "DIAMOND",
];

export const VIP_TIER_LABELS = Object.fromEntries(
  VIP_TIER_KEYS.map((tier) => [tier, tier])
);

/** Điểm thưởng mặc định (MAX_SCORE) khi BE chưa cấu hình */
export const DEFAULT_VIP_BONUS_POINTS = {
  NEW: 18,
  NORMAL: 20,
  COPPER: 22,
  SILVER: 24,
  GOLD: 26,
  PLATINUM: 28,
  EMERALD: 31,
  SAPPHIRE: 34,
  DIAMOND: 38,
};

/** Map key VIP cũ (khối 0–5 …) sang tier mới — đọc config legacy */
export const LEGACY_VIP_KEY_TO_TIER = {
  VIP_0_5: "NEW",
  VIP_6_11: "NORMAL",
  VIP_12_15: "SILVER",
  VIP_16_20: "DIAMOND",
};

export function resolveVipTierFromLevels(vipLevels, tierKey) {
  if (!vipLevels || typeof vipLevels !== "object") return null;
  if (vipLevels[tierKey]) return vipLevels[tierKey];
  const legacyKey = Object.keys(LEGACY_VIP_KEY_TO_TIER).find(
    (k) => LEGACY_VIP_KEY_TO_TIER[k] === tierKey
  );
  return legacyKey ? vipLevels[legacyKey] : null;
}
